import { useCallback, useRef } from 'react';
import classNames from 'classnames';
import { t } from 'i18next';
import styles from './product-area-filter-popup.module.scss';
import { Gtag } from '@/services/gtag';
import FiltersElementMain from '../product-area/filters-element-main';
import { LayoutStyleTypes } from "@/util-react/layout";
import { FixButton } from "@/elements-react/fix-button";
import { useProductArea } from '../product-area/context';
import DrawerPanel, { DrawerPanelHandle } from '../drawer-panel';


export const ProductAreaFilterPopup = () => {
    const store = useProductArea();
    const panelRef = useRef<DrawerPanelHandle>(null);
    const groupKey = 'filters' as const;

    const handleApply = useCallback(() => {
        store.applyFiltersPopup();
    }, []);

    const handleClear = useCallback(() => {
        Gtag.pushEvent("clear_filters_click", "");
        store.clearFiltersPopup();
    }, []);

    const handleClose = useCallback(() => {
        store.closeFiltersPopup();
    }, []);

    return (
        <DrawerPanel ref={panelRef} state={"visible"} onClose={handleClose} customDrawerVariant={"wide"}>
            <div className={classNames(styles.root)}>
                <div className={styles.header}>
                    <div className={styles.title}>{t("7hdv7w32qbxo8477.filter", "Filter")}</div>
                    {/* Shoelace React icon button, replace with actual import if needed */}
                    {/* <SlIconButton className={styles.close} name="x" onClick={onClose} /> */}
                </div>

                <div className={styles.content}>
                    <div className={styles.inner}>
                        <FiltersElementMain type={LayoutStyleTypes.TYPE_SM} group={groupKey} />
                    </div>
                </div>

                <div className={styles.footer}>
                    <FixButton onClick={handleClear} variant="default" size={'medium'}>
                        {t("38xtmz11ad14blsh.clear-all", "Clear All")}
                    </FixButton>

                    <FixButton onClick={handleApply} variant="primary" size={'medium'}>
                        {t("Apply", "Apply")}
                    </FixButton>
                </div>
            </div>
        </DrawerPanel>
    );
};

export default ProductAreaFilterPopup;
